<template>
  <div style="margin-top: 20px">
    <el-row class="subject">
      <el-col>基础学科</el-col>
    </el-row>
    <el-row class="table">
      <el-col :span="24">
        <el-table
          :data="basicData"
          size="medium"
          border
          :header-cell-style="{ background: '#f9f9f9' }"
          :row-style="{ height: '40px' }"
          :row-class-name="isRowAailable"
        >
          <el-table-column prop="name" label="学科"></el-table-column>
          <el-table-column prop="entryType" label="分数录入模式">
            <template slot-scope="scope">
              <span v-if="scope.row.entryType">{{
                _.filter(entryTypes, { value: scope.row.entryType })[0] &&
                _.filter(entryTypes, { value: scope.row.entryType })[0].name
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="tran" label="分数转换" align="center">
            <el-table-column
              v-for="(subject, index) in subjectTran"
              :key="subject.name"
              :label="subject.name"
            >
              <template slot-scope="scope">
                <span v-if="!scope.row.excellent && index === 0">-</span>
                <span v-if="scope.row.excellent && index === 0">{{
                  scope.row.excellent + "分以上"
                }}</span>
                <span v-if="!scope.row.good && index === 1">-</span>
                <span v-else-if="scope.row.good && index === 1">{{
                  scope.row.good + "分"
                }}</span>
                <span v-if="!scope.row.qualified && index === 2">-</span>
                <span v-else-if="scope.row.qualified && index === 2">{{
                  scope.row.qualified + "分"
                }}</span>
                <span v-if="!scope.row.failed && index === 3">-</span>
                <span v-else-if="scope.row.failed && index === 3">{{
                  scope.row.failed + "分以下"
                }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="term" label="学期分数计算" align="center" v-if="false">
            <el-table-column
              v-for="(term, index) in subjectTerm"
              :key="term.name"
              :label="term.name"
            >
              <template slot-scope="scope">
                <template v-if="junior >= 7">
                  <span v-if="!scope.row.normal && index === 0">-</span>
                  <span v-if="scope.row.normal && index === 0">{{
                    scope.row.normal + "%"
                  }}</span>
                  <span v-if="!scope.row.midterm && index === 1">-</span>
                  <span v-else-if="scope.row.midterm && index === 1">{{
                    scope.row.midterm + "%"
                  }}</span>
                  <span v-if="!scope.row.terminal && index === 2">-</span>
                  <span v-else-if="scope.row.terminal && index === 2">{{
                    scope.row.terminal + "%"
                  }}</span>
                </template>
                <template v-else>
                  <span v-if="!scope.row.normal && index === 0">-</span>
                  <span v-if="scope.row.normal && index === 0">{{
                    scope.row.normal + "%"
                  }}</span>
                  <span v-if="!scope.row.terminal && index === 1">-</span>
                  <span v-else-if="scope.row.terminal && index === 1">{{
                    scope.row.terminal + "%"
                  }}</span>
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="year" label="学年分数计算" align="center" v-if="false">
            <el-table-column
              v-for="(year, index) in subjectYear"
              :key="year.name"
              :label="year.name"
            >
              <template slot-scope="scope">
                <span v-if="!scope.row.semesterOne && index === 0">-</span>
                <span v-if="scope.row.semesterOne && index === 0">{{
                  scope.row.semesterOne + "%"
                }}</span>
                <span v-if="!scope.row.semesterTwo && index === 1">-</span>
                <span v-else-if="scope.row.semesterTwo && index === 1">{{
                  scope.row.semesterTwo + "%"
                }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="!scope.row.available"
                @click="handleEdit(scope.$index, scope.row, false)"
                >编辑</el-button
              >
              <el-button
                type="text"
                :disabled="scope.row.systemConfigured"
                @click="handleDisabled(scope.$index, scope.row)"
                >{{ scope.row.available ? "停用" : "启用" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row class="subject" style="margin-bottom: 10px">
      <el-col>校本学科</el-col>
    </el-row>
    <el-table
      :data="schoolData"
      size="medium"
      border
      :header-cell-style="{ background: '#f9f9f9' }"
      :row-style="{ height: '40px' }"
      :row-class-name="isRowAailable"
    >
      <el-table-column prop="name" label="学科"></el-table-column>
      <el-table-column prop="entryType" label="分数录入模式">
        <template slot-scope="scope">
          <span v-if="scope.row.entryType">{{
            _.filter(entryTypes, { value: scope.row.entryType })[0] &&
            _.filter(entryTypes, { value: scope.row.entryType })[0].name
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="tran" label="分数转换" align="center">
        <el-table-column
          v-for="(subject, index) in subjectTran"
          :key="subject.name"
          :label="subject.name"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.excellent && index === 0">-</span>
            <span v-if="scope.row.excellent && index === 0">{{
              scope.row.excellent + "分以上"
            }}</span>
            <span v-if="!scope.row.good && index === 1">-</span>
            <span v-else-if="scope.row.good && index === 1">{{
              scope.row.good + "分"
            }}</span>
            <span v-if="!scope.row.qualified && index === 2">-</span>
            <span v-else-if="scope.row.qualified && index === 2">{{
              scope.row.qualified + "分"
            }}</span>
            <span v-if="!scope.row.failed && index === 3">-</span>
            <span v-else-if="scope.row.failed && index === 3">{{
              scope.row.failed + "分以下"
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="term" label="学期分数计算" v-if="false">
        <el-table-column
          v-for="(term, index) in subjectTerm"
          :key="term.name"
          :label="term.name"
        >
          <template slot-scope="scope">
            <template v-if="junior >= 7">
              <span v-if="!scope.row.normal && index === 0">-</span>
              <span v-if="scope.row.normal && index === 0">{{
                scope.row.normal + "%"
              }}</span>
              <span v-if="!scope.row.midterm && index === 1">-</span>
              <span v-else-if="scope.row.midterm && index === 1">{{
                scope.row.midterm + "%"
              }}</span>
              <span v-if="!scope.row.terminal && index === 2">-</span>
              <span v-else-if="scope.row.terminal && index === 2">{{
                scope.row.terminal + "%"
              }}</span>
            </template>
            <template v-else>
              <span v-if="!scope.row.normal && index === 0">-</span>
              <span v-if="scope.row.normal && index === 0">{{
                scope.row.normal + "%"
              }}</span>
              <span v-if="!scope.row.terminal && index === 1">-</span>
              <span v-else-if="scope.row.terminal && index === 1">{{
                scope.row.terminal + "%"
              }}</span>
            </template>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="year" label="学年分数计算" v-if="false">
        <el-table-column
          v-for="(year, index) in subjectYear"
          :key="year.name"
          :label="year.name"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.semesterOne && index === 0">-</span>
            <span v-if="scope.row.semesterOne && index === 0">{{
              scope.row.semesterOne + "%"
            }}</span>
            <span v-if="!scope.row.semesterTwo && index === 1">-</span>
            <span v-else-if="scope.row.semesterTwo && index === 1">{{
              scope.row.semesterTwo + "%"
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="!scope.row.available"
            @click="handleEdit(scope.$index, scope.row, true)"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="handleDisabled(scope.$index, scope.row)"
            >{{ scope.row.available ? "停用" : "启用" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <subject-editor
      :visible.sync="editorVisible"
      :identify="subjectInfo"
      @edit-result="initData"
    ></subject-editor>
  </div>
</template>

<script>
import _ from 'lodash'
import SubjectEditor from '@/components/school-admin/affair/SubjectEditor'
export default {
  props: ['junior', 'gradesInfo'],

  components: {
    'subject-editor': SubjectEditor
  },

  data () {
    return {
      basicData: [],
      schoolData: [],
      entryTypes: [
        {
          name: '分值',
          value: 1
        },
        {
          name: '等第',
          value: 2
        }
      ],
      subjectTran: [
        {
          name: 'A'
        },
        {
          name: 'B'
        },
        {
          name: 'C'
        },
        {
          name: 'D'
        }
      ],
      subjectTerm: [
        {
          name: '平时'
        },
        {
          name: '期中'
        },
        {
          name: '期末'
        }
      ],
      subjectYear: [
        {
          name: '上学期'
        },
        {
          name: '下学期'
        }
      ],
      editorVisible: false,
      subjectInfo: {}
    }
  },

  watch: {
  },

  computed: {
    _ () {
      return _
    }
  },

  mounted () {
    this.initData()
  },

  methods: {
    initData () {
      if (this.junior >= 7) {
        this.subjectTerm = [
          {
            name: '平时'
          },
          {
            name: '期中'
          },
          {
            name: '期末'
          }
        ]
      } else {
        this.subjectTerm = [
          {
            name: '平时'
          },
          {
            name: '期末'
          }
        ]
      }
      this.$xhrGet(`/acc/grade/${this.junior}/subjects`, { feature: false }).then(rs => {
        this.basicData = rs.data
      })
      this.$xhrGet(`/acc/grade/${this.junior}/subjects`, { feature: true }).then(rs => {
        this.schoolData = rs.data
      })
    },

    handleEdit (index, row, subjectType) {
      this.editorVisible = true
      this.$set(row, 'subjectType', subjectType)
      this.$set(row, 'grade', this.junior)
      this.subjectInfo = _.cloneDeep(row)
    },

    handleDisabled (index, row) {
      this.$xhrPatch(`/acc/grade/subjects/${row.id}`, { available: !row.available }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initData()
        }
      })
    },

    isRowAailable ({ row, rowIndex }) {
      return 'zyyj-row-available-' + row.available
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 10px;
}
.table /deep/ .el-input__inner {
  border: none;
}
.hidenSpan {
  opacity: 0.6;
}
.select {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  color: var(--theme-color);
}
.subject {
  margin-top: 30px;
  font-size: 14px;
  font-weight: 500;
  color: #444444;
}
/deep/ tbody tr td {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/SubjectTabContent.vue